import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const AdminSidebar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  const navItems = [
    { id: "dashboard", icon: "📊", label: "Dashboard", path: "/admin" },
    { id: "users", icon: "👥", label: "Users", path: "/admin/users" },
    {
      id: "support",
      icon: "💬",
      label: "Support",
      path: "/admin/support_messages",
    },
    { id: "settings", icon: "⚙️", label: "Settings", path: "/admin/settings" },
  ];

  return (
    <aside
      className={`bg-gray-900 text-white h-screen flex flex-col transition-all duration-300 ${
        isExpanded ? "w-48" : "w-20"
      } border-r border-gray-700`}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      <nav className="flex flex-col gap-1 p-2 flex-1 mt-4">
        {navItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (item.path !== "/admin" && location.pathname.startsWith(item.path));

          return (
            <Link
              key={item.id}
              to={item.path}
              className={`flex items-center gap-3 px-3 py-3 rounded-lg transition-all duration-200 whitespace-nowrap ${
                isActive
                  ? "bg-gray-700 text-white"
                  : "text-gray-300 hover:bg-gray-800 hover:text-white"
              }`}
              title={item.label}
            >
              <span className="text-xl flex-shrink-0">{item.icon}</span>
              {isExpanded && (
                <span className="text-sm font-medium">{item.label}</span>
              )}
            </Link>
          );
        })}
      </nav>

      <div className="p-2 border-t border-gray-700">
        <Link
          to="/"
          className="flex items-center gap-3 px-3 py-3 rounded-lg text-gray-300 hover:bg-gray-800 transition-all"
          title="Exit Admin"
        >
          <span className="text-xl">🚪</span>
          {isExpanded && <span className="text-sm">Exit Admin</span>}
        </Link>
      </div>
    </aside>
  );
};

export default AdminSidebar;
